(function waitForGrowave() {
    const observer = new MutationObserver(() => {
        const host = document.querySelector('.gw-rd-referral-program-page-widget-placeholder');
        if (host && host.shadowRoot) {
            const wrapper = host.closest('.page-width');
            if (wrapper) {
                wrapper.classList.remove('page-width--full');
                wrapper.classList.add('custom-gw-rd-referral-program-page-widget-placeholder-section');
            }
            const shadow = host.shadowRoot;

            const style = document.createElement('style');
            style.textContent = `
                .gw-rd-referral-program-page-widget .gw-rd-page-widget-container{
                    padding: 0!important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-page-widget-layout{
                    width: 100%;
                    max-width: unset!important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-referral-program-page-widget__benefits{
                    order:1;
                    width: 50%;
                    flex:unset!important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-referral-program-page-widget__refer-friend{
                    flex:1;
                    gap:0px!important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-referral-program-page-widget__benefits .gw-rd-page-widget-title {
                    display: none !important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-referral-program-page-widget__benefits-description{
                    display: none !important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-referral-program-page-widget__benefits-image{
                    border-radius:0!important;
                    height: auto!important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-page-widget-title{
                    font-size: 45px!important;
                    line-height:60px!important;
                    color: #222!important;
                    margin-bottom: 10px!important;
                }
                .gw-rd-referral-program-page-widget .gw-list-reset-default-styles .gw-layout-text{
                    font-size:16px!important;
                    line-height: 22px !important;
                    font-weight: 400!important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-popup-widget-referral-program .gw-layout-text{
                    font-size:14px!important;
                }
                .gw-rd-referral-program-page-widget .gw-layout-text--variant-secondary{
                    color: #000!important;
                    line-height: normal!important;
                }
                .gw-rd-referral-program-page-widget .gw-layout-text--variant-primary{
                    font-weight:800!important;
                    line-height:normal!important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-popup-widget-referral-program__reward{
                    border-radius: 100px!important;
                    padding: 4px 23px!important;
                    background-color: #F0F0F0!important;
                    border: 1px solid transparent!important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-referral-program-page-widget__refer-friend-description{
                    gap:18px!important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-popup-widget-referral-program{
                    gap:14px!important;
                }
                
                .gw-rd-referral-program-page-widget .gw-rd-text-field{
                    border-radius: 100px!important;
                }
                .gw-rd-referral-program-page-widget .gw-rd-text-field__input{
                    color:#545454!important;
                    font-size:15px!important;
                }

                .gw-rd-referral-program-page-widget .gw-btn.gw-rd-action-btn{
                    border-radius:36px!important;
                    padding: 6px 36px 8px!important;
                    min-width: 150px!important;
                }
                .gw-rd-referral-program-page-widget .gw-btn.gw-rd-action-btn--primary{
                    background-color: #1e1e1e!important;
                }
                .gw-rd-referral-program-page-widget .gw-btn.gw-rd-action-btn--secondary{
                    border: 1px solid #1e1e1e!important;
                }


                @media (max-width: 899px) {
                    .gw-rd-referral-program-page-widget .gw-rd-referral-program-page-widget__layout{
                        flex-direction: column;
                        width: 100%;
                        gap:32px;
                        align-items: unset;
                    }
                    .gw-rd-referral-program-page-widget .gw-rd-referral-program-page-widget__benefits{
                        order:0;
                        width: 100%;
                    }
                    .gw-rd-referral-program-page-widget .gw-rd-referral-program-page-widget__benefits-image{
                        height: calc(260/425*100%)!important;
                    }
                    .gw-rd-referral-program-page-widget .gw-rd-referral-program-page-widget__refer-friend{
                        padding-left: var(--page-padding);
                        padding-right: var(--page-padding);
                    }


                    .gw-rd-referral-program-page-widget .gw-rd-page-widget-title{
                        font-size: 24px!important;
                        line-height: 28px!important;
                        margin-bottom: 16px!important;
                    }
                    .gw-rd-referral-program-page-widget .gw-rd-referral-program-page-widget__refer-friend-description{
                        gap:0px!important;
                    }
                    .gw-rd-referral-program-page-widget .gw-list-reset-default-styles{
                        margin-bottom:16px!important;

                    }
                    .gw-rd-referral-program-page-widget .gw-list-reset-default-styles .gw-layout-text{
                        font-size:16px!important;
                        line-height: 24px !important;
                        color: rgba(0, 0, 0, 0.66)!important;
                    }
                    .gw-rd-referral-program-page-widget .gw-rd-popup-widget-referral-program .gw-layout-text{
                        font-size:12px!important;
                    }
                    .gw-rd-referral-program-page-widget .gw-rd-popup-widget-referral-program__reward{
                        border-radius: 100px!important;
                        padding: 6px 16px!important;
                        border: 1px solid transparent!important;
                        margin-bottom:12px!important;
                    }
                    .gw-rd-referral-program-page-widget .gw-btn.gw-rd-action-btn{
                        border-radius:20px!important;
                        padding: 8px 32px!important;
                        min-width: 120px!important;
                    }
                    .gw-rd-referral-program-page-widget  .gw-rd-referral-program-page-widget__refer-friend-btns .gw-btn.gw-rd-action-btn--primary{
                        width: unset!important;
                    }
                    .gw-rd-referral-program-page-widget .gw-layout-text{
                        font-size:14px!important;
                    }
                    .gw-rd-popup-widget-referral-program-share{
                        gap:20px!important;
                    }



                }
            
      `;
            shadow.appendChild(style);
            console.log('✅ <style> 已注入到 shadow DOM');


            // Step3: 修改最近父级 page-width 样式（只针对加了 gw-rd-wrapper 的）
            const css = document.createElement('style');
            css.textContent = `
               @media (max-width: 899px) {
                .custom-gw-rd-referral-program-page-widget-placeholder-section{
                    padding-inline: 0;
                }
               }
                
              `;
            document.head.appendChild(css);

            observer.disconnect(); // 找到后停止监听
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();